
const Login = () => import(/* webpackChunkName: "guest" */ '../../views/auth/Login');
const Verify = () => import(/* webpackChunkName: "guest" */ '../../views/auth/Verify');
const Email = () => import(/* webpackChunkName: "guest" */ '../../views/auth/passwords/Email');
const Reset = () => import(/* webpackChunkName: "guest" */ '../../views/auth/passwords/Reset');

export  default  [
    {
        path: '*',
        component:Login,
    },
    {
        path: '/',
        component:Login,
    },
    {
        path: '/login/email/verify/:id/:hash',
        component:Verify,
    },
    {
        path: '/password/reset',
        component:Email,
    },
    {
        path: '/password/reset/:token',
        component:Reset,
    },
]
